module.exports = __webpack_public_path__ + "img/gears.394100ce.svg";